import { useEffect, useState } from 'react';

type DeviceOrientation = {
  isPortrait: boolean;
  isLandscape: boolean;
};

const PORTRAIT_MEDIA_QUERY = '(orientation: portrait)';

const getDeviceOrientation = (): DeviceOrientation => {
  if (typeof window === 'undefined') {
    return {
      isPortrait: true,
      isLandscape: false,
    };
  }

  const isPortrait = window.matchMedia(PORTRAIT_MEDIA_QUERY).matches;

  return {
    isPortrait,
    isLandscape: !isPortrait,
  };
};

const useDeviceOrientation = (): DeviceOrientation => {
  const [deviceOrientation, setDeviceOrientation] =
    useState<DeviceOrientation>(getDeviceOrientation);

  useEffect(() => {
    if (typeof window === 'undefined') {
      return undefined;
    }

    const mediaQueryList = window.matchMedia(PORTRAIT_MEDIA_QUERY);

    const updateDeviceOrientation = () => {
      setDeviceOrientation(getDeviceOrientation());
    };

    updateDeviceOrientation();

    if (typeof mediaQueryList.addEventListener === 'function') {
      mediaQueryList.addEventListener('change', updateDeviceOrientation);
    } else {
      mediaQueryList.addListener(updateDeviceOrientation);
    }

    window.addEventListener('resize', updateDeviceOrientation);
    window.addEventListener('orientationchange', updateDeviceOrientation);

    return () => {
      if (typeof mediaQueryList.removeEventListener === 'function') {
        mediaQueryList.removeEventListener('change', updateDeviceOrientation);
      } else {
        mediaQueryList.removeListener(updateDeviceOrientation);
      }

      window.removeEventListener('resize', updateDeviceOrientation);
      window.removeEventListener('orientationchange', updateDeviceOrientation);
    };
  }, []);

  return deviceOrientation;
};

export default useDeviceOrientation;
